import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import LocationPicker from '../../LocationPicker/LocationPicker';
import { s } from '../../../utils/libs';
import useLocation from '../../../hooks/useLocation';
import HeaderTitle from './HeaderTitle';

interface HeaderLocationPickerProps {
  showAllLocationsOption?: boolean;
}

const HeaderLocationPicker: React.FC<HeaderLocationPickerProps> = ({
  showAllLocationsOption = false,
}) => {
  const { isAdmin } = useLocation();

  // If user is not allowed to switch locations, keep existing logo header
  if (!isAdmin) {
    return <HeaderTitle />;
  }

  return (
    <View style={styles.container}>
      <LocationPicker
        variant="compact"
        textColor="#fff"
        showAllLocationsOption={showAllLocationsOption}
      />
    </View>
  );
};

export default HeaderLocationPicker;

const styles = StyleSheet.create({
  container: {
    paddingRight: s(6),
    ...(Platform.OS === 'web' && { alignItems: 'center' as const }),
  },
});
